import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-months-value',
  templateUrl: './months-value.component.html',
  styleUrls: ['./months-value.component.scss']
})
export class MonthsValueComponent implements OnInit {

  constructor() { }

  amountJanuary:number=101;
  amountFebruary:number=102;
  amountMarch:number=103;
  amountApril:number=101;
  amountMay:number=105;
  amountJune:number=108;
  amountJuly:number=109;
  amountAugust:number=150;
  amountSeptember:number=610;
  amountOctober:number=106;
  amountNovember:number=190;
  amountDecember:number=160;
  total:number;

  statJanuary:number=10;
  statFebruary:number=10;
  statMarch:number=10;
  statApril:number=10;
  statMay:number=10;
  statJune:number=10;
  statJuly:number=10;
  statAugust:number=10;
  statSeptember:number=10;
  statOctober:number=10;
  statNovember:number=10;
  statDecember:number=10;


  ngOnInit() {
    this.total=this.amountJanuary+this.amountFebruary+this.amountMarch+this.amountApril+this.amountMay+this.amountJune+this.amountJuly
      +this.amountAugust+this.amountSeptember+this.amountOctober+this.amountNovember+this.amountDecember;
    this.statJanuary=this.amountJanuary*100/this.total;
    this.statFebruary=this.amountFebruary*100/this.total;
    this.statMarch=this.amountMarch*100/this.total;
    this.statApril=this.amountApril*100/this.total;
    this.statMay=this.amountMay*100/this.total;
    this.statJune=this.amountJune*100/this.total;
    this.statJuly=this.amountJuly*100/this.total;
    this.statAugust=this.amountAugust*100/this.total;
    this.statSeptember=this.amountSeptember*100/this.total;
    this.statOctober=this.amountOctober*100/this.total;
    this.statNovember=this.amountNovember*100/this.total;
    this.statDecember=this.amountDecember*100/this.total;
  }

}



// WEBPACK FOOTER //
// D:/Workspace/hyblab-migration/src/app/months-value/months-value.component.ts